<template>
  <div id="app-etsy-converter-wrapper">
    <div v-if="!successMessage" class="upload-wrapper" v-bind="getRootProps()">
      <input v-bind="getInputProps()"/>
      <p v-if="isDragActive && !fileName">Lade deine CSV hier aus Etsy hoch, um diese Datei für lexoffice zu konvertieren.</p>
      <p v-else-if="!fileName">Ziehe deine Etsy CSV-Datei hierher, oder klicke, um die Datei auszuwählen.</p>
      <p v-if="fileName">Hochgeladene Datei: {{ fileName }}</p>
    </div>

    <div v-if="successMessage" class="upload-wrapper-success">
      {{ successMessage }}
    </div>

    <a v-if="!successMessage" class="app-etsy-converter-button" @click="sendFileToAPI"
       :class="{ 'disabled': (!fileName) }">CSV konvertieren</a>

    <a v-if="successMessage" class="app-etsy-converter-button" :href="fileUrl" @click="removeFileToApi">Download</a>
  </div>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue';
import { useDropzone } from 'vue3-dropzone';

export default {
  name: 'UseDropzoneEtsyConverter',
  setup() {
    const fileName = ref('');
    const successMessage = ref('');
    const file = ref(null);
    const fileUrl = ref('');

    const onDrop = (acceptedFiles) => {
      fileName.value = acceptedFiles[0].name;
      file.value = acceptedFiles[0];
    };

    const sendFileToAPI = async () => {
      if (!file.value) return;

      const formData = new FormData();
      formData.append('file', file.value);

      try {
        const response = await fetch('/wp-json/ec/v1/converter/', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
        });

        const responseData = await response.json();

        if (response.ok && responseData?.status === 200) {
          successMessage.value = 'Die Datei wurde erfolgreich konvertiert und kann jetzt heruntergeladen werden.';
          fileUrl.value = responseData.file;
        } else {
          alert('Fehler beim Konvertieren der Datei.');
        }
      } catch (error) {
        alert('Fehler beim Senden der Datei.');
      }
    };

    const removeFileToApi = async () => {
      if (!fileUrl.value) return;

      const formData = new FormData();
      formData.append('file', fileUrl.value);

      await fetch('/wp-json/ec/v1/converter/remove', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      });

      fileName.value = '';
      successMessage.value = '';
      fileUrl.value = '';
      file.value = null;
    };

    const handleBeforeUnload = async (event) => {
      if (fileUrl.value) {
        await removeFileToApi();
      }
      event.preventDefault();
      event.returnValue = '';
    };

    const handleUnload = async () => {
      if (fileUrl.value) {
        await removeFileToApi();
      }
    };

    onMounted(() => {
      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('unload', handleUnload);
    });

    onUnmounted(() => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    });

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: '.csv', multiple: false });

    return {
      getRootProps,
      getInputProps,
      isDragActive,
      fileName,
      successMessage,
      sendFileToAPI,
      removeFileToApi,
      fileUrl,
    };
  },
};
</script>

<style scoped>
#app-etsy-converter-wrapper {
  background-color: #BAD1C5;
  color: #fff;
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 14px;
}

.upload-wrapper, .upload-wrapper-success {
  margin: 20px 0;
  padding: 30px 20px;
  border-radius: 10px;
  border: 1px dashed #ffffff;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}

.upload-wrapper:focus, .upload-wrapper-success:focus {
  outline: none;
}

.app-etsy-converter-button {
  display: block;
  cursor: pointer;
  padding: 10px;
  background-color: #ffffff;
  color: #FFC370 !important;
  border: 1px solid #ffffff;
  border-radius: 5px;
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  width: 80%;
  margin: 20px auto;
}

.app-etsy-converter-button:not(.disabled):hover {
  background-color: #FFC370;
  color: #ffffff !important;
  border-color: #FFC370;
}

.app-etsy-converter-button.disabled {
  cursor: not-allowed;
}
</style>
